import { useRef } from 'react'

/**
 * Returns `value` while `active` is false, capturing it each render. While `active` is
 * true it returns the last value captured before `active` flipped true — i.e. it "freezes"
 * the value for the duration of `active`. Used to keep series-identity chrome (legend
 * labels) matching the on-screen (kept) data during a refetch.
 */
export function useFreezeWhile<T>(active: boolean, value: T): T {
  const frozen = useRef(value)
  if (!active) {
    frozen.current = value
  }
  return active ? frozen.current : value
}
